import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const StudentsRepository = RepositoryFactory.get("students");

const state = {
  students: [],
  student: {},
};

const getters = {
  getStudents: () => state.students,
  getStudent: () => state.student,
};

const actions = {
  getStudents({ commit, dispatch, state }, params = {}) {
    dispatch("loadings/enableLoadings", {}, { root: true });
    StudentsRepository.getStudents(params)
      .then((response) => {
        const students = response.data.results;
        const totalPages = response.data.total_pages;
        commit("pagination/SET_TOTAL_PAGES", totalPages, { root: true });
        commit("SAVE_STUDENTS", students);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(
              `message.notifications.students.getStudentsError`,
            ),
          },
          { root: true },
        );
      })
      .finally(() => {
        dispatch("loadings/disableLoadings", {}, { root: true });
      });
  },
  getStudent({ dispatch, commit }, id) {
    return StudentsRepository.getStudent(id)
      .then((response) => {
        const student = response.data;
        commit("SAVE_STUDENT", student);
      })
      .catch(() => {
        dispatch(
          "notifications/addError",
          {
            message: state.$t(`message.notifications.students.getStudentError`),
          },
          { root: true },
        );
      });
  },
  createStudent({ dispatch, commit }, payload) {
    return StudentsRepository.createStudent(payload)
      .then((response) => {
        const student = response.data;
        commit("SAVE_STUDENT", student);

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.students.createStudentSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((e) => {
        let message = "";

        try {
          if (e.response.data["message"] === "email_already_used") {
            message = state.$t(`message.notifications.emailExists`);
          } else {
            message = state.$t(
              `message.notifications.students.createStudentError`,
            );
          }
        } catch (error) {
          // No data, unknown error (probably 500)
          message = state.$t(
            `message.notifications.students.createStudentError`,
          );
        }

        dispatch(
          "notifications/addError",
          {
            message: message,
          },
          { root: true },
        );
        throw e;
      });
  },
  updateStudent({ dispatch, commit }, payload) {
    const id = payload.id;
    return StudentsRepository.updateStudent(id, payload)
      .then((response) => {
        const student = response.data;
        commit("SAVE_STUDENT", student);

        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(
              `message.notifications.students.updateStudentSuccess`,
            ),
          },
          { root: true },
        );
      })
      .catch((e) => {
        let message = "";

        try {
          if (e.response.data[0] === "email_already_used") {
            message = state.$t(`message.notifications.emailExists`);
          } else {
            message = state.$t(
              `message.notifications.students.updateStudentError`,
            );
          }
        } catch (error) {
          // No data, unknown error (probably 500)
          message = state.$t(
            `message.notifications.students.updateStudentError`,
          );
        }

        dispatch(
          "notifications/addError",
          {
            message: message,
          },
          { root: true },
        );
        throw e;
      });
  },
  resetStudents({ commit }) {
    commit("RESET_STUDENTS");
  },
  resetCurrentStudent({ commit }) {
    commit("RESET_STUDENT");
  },
  setStudentFromList({ commit, state }, studentId) {
    const student = state.students.find((s) => s.id === studentId);
    commit("SAVE_STUDENT", student);
  },
};

const mutations = {
  SAVE_STUDENTS(state, students) {
    state.students = students;
  },
  SAVE_STUDENT(state, student) {
    state.student = student;
  },
  RESET_STUDENT(state) {
    state.student = {};
  },
  RESET_STUDENTS(state) {
    state.students = [];
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
